(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koala-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('koalaCartForm');
    if (!form) return;

    // quantity steppers auto-submit for a smooth update
    form.querySelectorAll('.koala-qty').forEach(function (wrap) {
      var input = wrap.querySelector('.koala-qty__input');
      wrap.querySelectorAll('.koala-qty__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 0;
          v = btn.dataset.dir === 'up' ? v + 1 : Math.max(0, v - 1);
          input.value = v;
          form.submit();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('koalaCollForm');
    if (!form) return;
    var toggle = document.getElementById('koalaFilterToggle');
    var panel = document.getElementById('koalaFilters');
    var closeBtn = document.getElementById('koalaFilterClose');
    var scrim = document.getElementById('koalaFilterScrim');

    function open() {
      if (!panel) return;
      panel.classList.add('is-open');
      scrim.hidden = false;
      requestAnimationFrame(function () { scrim.classList.add('is-open'); });
      document.body.classList.add('koala-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (!panel) return;
      panel.classList.remove('is-open');
      scrim.classList.remove('is-open');
      document.body.classList.remove('koala-lock');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () { scrim.hidden = true; }, 350);
    }
    if (toggle) toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var lists = (root || document).querySelectorAll('.koala-faq__list');
      lists.forEach(function (list) {
        var items = list.querySelectorAll('.koala-faq__item');
        items.forEach(function (item) {
          if (item.dataset.koalaFaqBound) return;
          item.dataset.koalaFaqBound = '1';
          item.addEventListener('toggle', function () {
            if (!item.open) return;
            items.forEach(function (other) {
              if (other !== item) other.open = false;
            });
          });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-header"]) return;
  try {
    
  (function () {
    var head = document.getElementById('koalaHead');
    var transparentEligible = head.dataset.transparentEligible === '1';
    function onScroll() {
      if (transparentEligible) head.classList.toggle('is-solid', window.scrollY > 40);
    }
    onScroll();
    if (transparentEligible) window.addEventListener('scroll', onScroll, { passive: true });

    /* search overlay */
    var searchBtn = document.getElementById('koalaSearchBtn');
    var overlay = document.getElementById('koalaSearchOverlay');
    var backdrop = document.getElementById('koalaSearchBackdrop');
    var closeBtn = document.getElementById('koalaSearchClose');
    var input = document.getElementById('koalaSearchInput');
    var hint = document.getElementById('koalaSearchHint');
    var resultsEl = document.getElementById('koalaSearchResults');
    var emptyEl = document.getElementById('koalaSearchEmpty');
    var searchTimer = null;

    function openSearch() {
      overlay.classList.add('is-open');
      document.body.classList.add('koala-lock');
      searchBtn.setAttribute('aria-expanded', 'true');
      setTimeout(function () { input.focus(); }, 60);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('koala-lock');
      searchBtn.setAttribute('aria-expanded', 'false');
    }
    function runSearch(term) {
      term = term.trim();
      if (!term) {
        hint.hidden = false;
        resultsEl.hidden = true;
        emptyEl.hidden = true;
        resultsEl.innerHTML = '';
        return;
      }
      hint.hidden = true;
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            resultsEl.hidden = true;
            emptyEl.hidden = false;
            return;
          }
          emptyEl.hidden = true;
          resultsEl.hidden = false;
          resultsEl.innerHTML = products
            .map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              return (
                '<li><a href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '') +
                '<span><span class="koala-sr-name">' + p.title + '</span>' +
                '<span class="koala-sr-price">' + (p.price || '') + '</span></span></a></li>'
              );
            })
            .join('');
        })
        .catch(function () {});
    }
    searchBtn.addEventListener('click', openSearch);
    closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);
    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var val = input.value;
      searchTimer = setTimeout(function () { runSearch(val); }, 220);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });

    /* mobile nav */
    var menuBtn = document.getElementById('koalaMenuBtn');
    var mobileNav = document.getElementById('koalaMobileNav');
    var mobileBackdrop = document.getElementById('koalaMobileNavBackdrop');
    var mobileClose = document.getElementById('koalaMobileNavClose');
    var mobileSearchBtn = document.getElementById('koalaMobileSearchBtn');

    function openMobileNav() {
      mobileNav.classList.add('is-open');
      document.body.classList.add('koala-lock');
      menuBtn.setAttribute('aria-expanded', 'true');
    }
    function closeMobileNav() {
      mobileNav.classList.remove('is-open');
      document.body.classList.remove('koala-lock');
      menuBtn.setAttribute('aria-expanded', 'false');
    }
    menuBtn.addEventListener('click', function () {
      mobileNav.classList.contains('is-open') ? closeMobileNav() : openMobileNav();
    });
    mobileClose.addEventListener('click', closeMobileNav);
    mobileBackdrop.addEventListener('click', closeMobileNav);
    mobileSearchBtn.addEventListener('click', function () {
      closeMobileNav();
      setTimeout(openSearch, 250);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMobileNav();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var cues = (root || document).querySelectorAll('.koala-hero__scrollcue');
      cues.forEach(function (cue) {
        if (cue.dataset.koalaCue) return;
        cue.dataset.koalaCue = '1';
        cue.addEventListener('click', function (e) {
          var targetId = (cue.getAttribute('href') || '').slice(1);
          var el = targetId ? document.getElementById(targetId) : null;
          if (!el) {
            var wrapper = cue.closest('.shopify-section') || cue.closest('.koala-hero');
            el = wrapper ? wrapper.nextElementSibling : null;
          }
          if (el) {
            e.preventDefault();
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-product-main"]) return;
  try {
    
  class KoalaProductForm extends HTMLElement {
    connectedCallback() {
      var root = this;
      var pdp = root.closest('.koala-pdp');
      var variants = JSON.parse(root.dataset.variants || '[]');
      var selected = {};

      root.querySelectorAll('[data-option-index].koala-pdp__option').forEach(function (group) {
        var idx = group.dataset.optionIndex;
        var activeBtn = group.querySelector('.is-selected') || group.querySelector('.koala-pdp__option-btn');
        if (activeBtn) selected[idx] = activeBtn.dataset.value;
      });

      function findVariant() {
        return variants.find(function (v) {
          return Object.keys(selected).every(function (idx) {
            return v.options[Number(idx)] === selected[idx];
          });
        });
      }

      function updateUI(variant) {
        if (!variant) return;
        var priceEl = pdp.querySelector('[data-price] .koala-pdp__price-now');
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        var wasEl = pdp.querySelector('[data-price] .koala-pdp__price-was');
        if (wasEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            wasEl.textContent = formatMoney(variant.compare_at_price);
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }
        var atc = root.querySelector('[data-add-to-cart]');
        var label = root.querySelector('[data-atc-label]');
        if (atc && label) {
          if (variant.available) {
            atc.removeAttribute('disabled');
            label.textContent = 'Add to cart';
          } else {
            atc.setAttribute('disabled', 'disabled');
            label.textContent = 'Sold out';
          }
        }
        var paymentInput = root.querySelector('[data-payment-variant-id]');
        if (paymentInput) paymentInput.value = variant.id;
        var paymentWrap = pdp.querySelector('[data-payment-wrap]');
        if (paymentWrap) paymentWrap.hidden = !variant.available;

        var stickyPrice = pdp.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        var stickyAtc = pdp.querySelector('[data-sticky-add-to-cart]');
        var stickyLabel = pdp.querySelector('[data-sticky-atc-label]');
        if (stickyAtc && stickyLabel) {
          if (variant.available) {
            stickyAtc.removeAttribute('disabled');
            stickyLabel.textContent = 'Add to cart';
          } else {
            stickyAtc.setAttribute('disabled', 'disabled');
            stickyLabel.textContent = 'Sold out';
          }
        }

        if (variant.featured_media) {
          var mediaId = variant.featured_media.id;
          var slide = pdp.querySelector('.koala-pdp__slide[data-media-id="' + mediaId + '"]');
          if (slide) {
            pdp.querySelectorAll('.koala-pdp__slide').forEach(function (s) { s.classList.remove('is-active'); });
            slide.classList.add('is-active');
            pdp.querySelectorAll('.koala-pdp__thumb').forEach(function (t) {
              t.classList.toggle('is-active', t.dataset.thumbFor === String(mediaId));
            });
          }
        }
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      root.querySelectorAll('.koala-pdp__option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.dataset.optionIndex;
          selected[idx] = btn.dataset.value;
          btn.parentElement.querySelectorAll('.koala-pdp__option-btn').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
          var variant = findVariant();
          if (variant) updateUI(variant);
        });
      });

      var qtyInput = root.querySelector('[data-qty-input]');
      var minus = root.querySelector('[data-qty-minus]');
      var plus = root.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (plus) plus.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });

      function addSelectedToCart(btn) {
        var variant = findVariant() || variants[0];
        if (!variant || !variant.available) return;
        var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
        if (btn) btn.classList.add('is-loading');
        window.KoalaCart.addItem(variant.id, qty)
          .then(function () {
            if (btn) btn.classList.remove('is-loading');
            var msg = pdp.querySelector('[data-added-msg]');
            if (msg) {
              msg.hidden = false;
              setTimeout(function () { msg.hidden = true; }, 3000);
            }
          })
          .catch(function () { if (btn) btn.classList.remove('is-loading'); });
      }

      var atcBtn = root.querySelector('[data-add-to-cart]');
      if (atcBtn) {
        atcBtn.addEventListener('click', function () { addSelectedToCart(atcBtn); });
      }

      /* Sticky mobile add-to-cart bar: visible by default so the purchase
         action is always reachable, hides only while the real buy row is
         actually on screen. */
      var stickyBar = pdp.querySelector('[data-sticky-atc]');
      var buyRow = pdp.querySelector('.koala-pdp__buy-row');
      if (stickyBar && buyRow) {
        var stickyAtcBtn = stickyBar.querySelector('[data-sticky-add-to-cart]');
        if (stickyAtcBtn) {
          stickyAtcBtn.addEventListener('click', function () { addSelectedToCart(stickyAtcBtn); });
        }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              stickyBar.hidden = false;
              stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
            });
          }, { threshold: 0 }).observe(buyRow);
        } else {
          stickyBar.hidden = false;
          stickyBar.classList.add('is-visible');
        }
      }

      pdp.querySelectorAll('.koala-pdp__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.dataset.thumbFor;
          pdp.querySelectorAll('.koala-pdp__slide').forEach(function (s) {
            s.classList.toggle('is-active', s.dataset.mediaId === id);
          });
          pdp.querySelectorAll('.koala-pdp__thumb').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
          });
        });
      });
    }
  }
  if (!customElements.get('product-form')) {
    customElements.define('product-form', KoalaProductForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-products"] && !Shopify.designMode) return;
  try {
    
  class KoalaProductsSlider extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      var prevBtn = this.querySelector('[data-prev]');
      var nextBtn = this.querySelector('[data-next]');
      if (!track) return;

      function step() {
        var item = track.querySelector('.koala-prods__item');
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = max <= 2 || track.scrollLeft >= max - 2;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { update(); raf = null; });
      });
      window.addEventListener('resize', update);
      update();
    }
  }
  customElements.define('koala-products-slider', KoalaProductsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-testimonials"] && !Shopify.designMode) return;
  try {
    
  class KoalaTestimonialSlider extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('.koala-testi__track');
      var slides = track.children.length;
      if (!slides) return;
      var dotsEl = this.querySelector('[data-dots]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0;
      var timer = null;

      for (var s = 0; s < slides; s++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Testimonial ' + (idx + 1));
          if (idx === 0) b.classList.add('is-active');
          b.addEventListener('click', function () { go(idx, true); });
          dotsEl.appendChild(b);
        })(s);
      }

      var sliderEl = this.querySelector('.koala-testi__slider');
      function setHeight() {
        var active = track.children[i];
        if (active) sliderEl.style.height = active.getBoundingClientRect().height + 'px';
      }

      function go(idx, manual) {
        i = (idx + slides) % slides;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        [].forEach.call(dotsEl.children, function (d, di) {
          d.classList.toggle('is-active', di === i);
        });
        setHeight();
        if (manual) restart();
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (!reduce) timer = setInterval(function () { go(i + 1); }, 5200);
      }

      this.querySelector('[data-next]').addEventListener('click', function () { go(i + 1, true); });
      this.querySelector('[data-prev]').addEventListener('click', function () { go(i - 1, true); });
      restart();
      requestAnimationFrame(setHeight);
      window.addEventListener('resize', setHeight);
    }
  }
  customElements.define('koala-testimonial-slider', KoalaTestimonialSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koala-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var vids = (root || document).querySelectorAll('.koala-video video');
      if (!vids.length) return;
      function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      vids.forEach(function (v) {
        if (v.dataset.koalaVid) return;
        v.dataset.koalaVid = '1';
        play(v);
        v.addEventListener('loadeddata', function () { play(v); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) play(e.target); else e.target.pause(); });
          }, { threshold: 0.25 }).observe(v);
        }
      });
      // fallback: start on first user gesture if a browser blocks muted autoplay
      var g = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
      function onG() { vids.forEach(play); g.forEach(function (e) { window.removeEventListener(e, onG); }); }
      g.forEach(function (e) { window.addEventListener(e, onG, { passive: true }); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
